var map = {
	"./de-CH/de-CH.locale": 60012,
	"./de-DE/de-DE.locale": 78480,
	"./en-AU/en-AU.locale": 32888,
	"./en-CA/en-CA.locale": 6156,
	"./en-GB/en-GB.locale": 79760,
	"./en-NZ/en-NZ.locale": 30412,
	"./en-US/en-US.locale": 41736,
	"./fr-BE/fr-BE.locale": 73708,
	"./fr-CA/fr-CA.locale": 30224,
	"./fr-CH/fr-CH.locale": 1772,
	"./fr-FR/fr-FR.locale": 74176,
	"./global/global.locale": 40824,
	"./nl-BE/nl-BE.locale": 87148,
	"./nl-NL/nl-NL.locale": 16520,
	"./sv-SE/sv-SE.locale": 79884
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53725;